module.exports = "<div class=switch> <label> {{leftLabel}} <input v-el:input type=checkbox v-model=value :disabled=disabled> <span class=lever></span> {{rightLabel}} </label> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-html-loader!../~/vue-loader/lib/selector.js?type=template&index=0!../~/material-ui-vue/components/forms/switch.vue
 ** module id = 278
 ** module chunks = 0
 **/